// hr
// export const MAIN_URL="https://www.afasteel.com/api/";
// export const MAIN_URL_IMAGE="https://www.afasteel.com";

// build
export const MAIN_URL="/api/";
export const MAIN_URL_IMAGE="";
